import { Observable } from 'rxjs';
import { Actions } from '../../actions';
import * as authActionCreators from '../../auth/action-creators';
import * as authActions from '../../auth/actions';
import { ofType } from 'redux-observable';
import { mergeMap } from 'rxjs/operators';
import { push } from 'connected-react-router';
import { isLoggedIn } from '@webapp/sdk/auth';

export const verificationSuccessEpic = (action$: Observable<Actions>) =>
  action$.pipe(
    ofType<Actions, authActionCreators.VerifyAccountSuccess>(
      authActions.VERIFY_ACCOUNT_SUCCESS
    ),
    mergeMap(async () => {
      const isLogged = await isLoggedIn();

      if (isLogged) {
        return push('/user/general');
      }

      return push('/login');
    })
  );
